import { render, staticRenderFns } from "./RegisterOnboardPage.vue?vue&type=template&id=781abdd5&"
import script from "./RegisterOnboardPage.vue?vue&type=script&lang=js&"
export * from "./RegisterOnboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports